import axios from 'axios';
import { Action, createAction, handleActions } from 'redux-actions';
import { FULFILLED, PENDING, REJECTED } from './action-type.util';
import { IMenuHistory as IModel } from './menu.model';
import {
    getAxiosData,
    getRejectedRespData,
    initPagingList,
    IPaging,
    parsePagingToParams,
    parseToPaging,
    SERVER_API_URL,
} from '../config/constants';

export const ACTION_TYPES = {
    UPDATE_STATE: 'menu/UPDATE_STATE',
    SET_PAGING: 'menu/SET_PAGING',
    RESET_PAGING: 'menu/RESET_PAGING',
    GET: 'menu/GET',
    GET_BY_ID: 'menu/GET_BY_ID',
};

export interface IMenuState {
    loading: boolean;
    error: any;
    list: IModel[];
    data: IModel;
    paging: IPaging;
}

const initState = {
    loading: false,
    error: null,
    list: [],
    data: {} as IModel,
    paging: { ...initPagingList },
};

export const updateState = createAction(ACTION_TYPES.UPDATE_STATE);
export const setPaging = createAction(ACTION_TYPES.SET_PAGING);
export const resetPaging = createAction(ACTION_TYPES.RESET_PAGING);

export const get = createAction<any, any>(ACTION_TYPES.GET, (params?: any) =>
    getAxiosData(
        axios.get(`${SERVER_API_URL}/menus-histories`, {
            params: parsePagingToParams({ ...initPagingList, ...params }),
        }),
    ),
);
export const getById = createAction(ACTION_TYPES.GET_BY_ID, (id: number) =>
    getAxiosData(axios.get(`${SERVER_API_URL}/menus-histories/${id}`)),
);

/* Reducer function */
const onPending = (state: IMenuState): IMenuState => ({ ...state, loading: true });
// const onPendingCancel = (state: IMenuState): IMenuState => ({ ...state, loading: false });
const onRejected = (state: IMenuState, action: Action<any>): IMenuState => ({
    ...state,
    error: getRejectedRespData(action.payload),
    loading: false,
});
const onSetItem = (state: IMenuState, action: Action<any>): IMenuState => ({
    ...state,
    loading: false,
    data: { ...action.payload },
});
/* Reducer function end */

export default handleActions<IMenuState, any>(
    {
        [ACTION_TYPES.UPDATE_STATE]: (state: IMenuState, action: Action<any>): IMenuState => ({
            ...state,
            ...action.payload,
        }),
        [ACTION_TYPES.SET_PAGING]: (state: IMenuState, action: Action<IPaging>): IMenuState => ({
            ...state,
            paging: { ...state.paging, ...parseToPaging(action.payload) },
        }),
        [ACTION_TYPES.RESET_PAGING]: (state: IMenuState): IMenuState => ({
            ...state,
            paging: { ...initPagingList },
        }),

        [PENDING(ACTION_TYPES.GET)]: onPending,
        [REJECTED(ACTION_TYPES.GET)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET)]: (state: IMenuState, action: Action<any>): IMenuState => {
            const { page: list = [], ...paging } = action.payload;
            return { ...state, loading: false, list, paging: { ...state.paging, ...paging } };
        },

        [PENDING(ACTION_TYPES.GET_BY_ID)]: onPending,
        [REJECTED(ACTION_TYPES.GET_BY_ID)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET_BY_ID)]: onSetItem,

        /* WS events */
        /* WS events end */
    },
    initState,
);
